import { RELATORIO } from "./types"
import api from "./api"

export const changeState = (key, value) => {
    return dispatch => {
        dispatch({ type: RELATORIO, payload: { [key]: value }})
    }
}

export const changeMultiState = (payload) => {
    return dispatch => {
        dispatch({ type: RELATORIO, payload })
    }
}

export const getRelatorio = (page, limit, params) => {
    return dispatch => {
        var data  = new FormData()
        dispatch({ type: RELATORIO, payload: { loading: true } })
        for(let i in params)
            data.append(i,params[i])

        api.post(`admin/relatorio/${page}/${limit}`, data)
        .then( async res => {
            var { payload } = res.data
            payload = { ...payload, loading: false }

            dispatch({ type: RELATORIO, payload })
        })
        .catch( error => {
            dispatch({ type: RELATORIO, payload: { loading: false } })
        })
    }
}
